import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '@mdi/react';
import { mdiCircleSlice1, mdiAlertCircleOutline } from '@mdi/js';
import { Spinner, Toast, ToastHeader, ToastBody } from 'reactstrap';

import './LoadingMessages.css';

const LoadingMessages = ({ isLoading, hasError, errorMessage }) => {
    const { t } = useTranslation();

    return (
        <div className="LoadingMessages">
            {hasError &&
                <Toast>
                    <ToastHeader icon="danger">
                        <h4>
                            {t('common.an_error_occured')}
                        </h4>
                    </ToastHeader>
                    <ToastBody>
                        <h5>
                            <span dangerouslySetInnerHTML={{__html: errorMessage}} />
                        </h5>
                    </ToastBody>
                </Toast>
            }

            {isLoading &&
                <Toast>
                    <ToastHeader  icon={<Spinner size="sm">Loading...</Spinner>}>
                        <h4>
                            {t('common.please_wait')}
                        </h4>
                    </ToastHeader>
                    <ToastBody>
                        {t('common.loading')}
                    </ToastBody>
                </Toast>
            }
        </div>
    );
}

export default LoadingMessages;
